import React from 'react';
import styles from './index.module.scss'

class Checkbox extends React.Component {

  render() {
    return (
      <div className={styles.cupra}>
        <div className={styles.containerCheck}>
          {
            this.props.bloqueado ?

              <input
                type="checkbox"
                className={`${styles.inputCheck} ${this.props.color ? styles.inputColor : ''}`}
                name={this.props.inputField?.name}
                id={this.props.inputField?.name}
                value={this.props.inputField?.value}
                onChange={this.props.inputField?.onChange}
                checked={true}
                disabled={true}
              />

              :

              <input
                type="checkbox"
                className={`${styles.inputCheck} ${this.props.color ? styles.inputColor : ''}`}
                name={this.props.inputField?.name}
                id={this.props.inputField?.name}
                value={this.props.inputField?.value}
                onChange={this.props.inputField?.onChange}
              />
          }
        </div>
        <label className={`${styles.inputLabel} ${this.props.color ? styles.labelColor : ''}`} htmlFor={this.props.inputField?.name}>{this.props.inputLabel}</label>
      </div>
    )
  }
}

export default Checkbox
